class CondoleancePopover extends HTMLElement {
  constructor() {
    super();

    this.masterAvisInfosContainer = document.querySelector('custom-avis-infos');

    this.condoleanceForm = document.getElementById('CondoleanceForm');

    this.condoleanceFormContainer = document.querySelector(
      '[data-form-container]'
    );
    this.condoleanceFormSuccess = document.querySelector('[data-form-success]');

    this.condoleanceFormFields =
      this.condoleanceForm.querySelectorAll('input, textarea');
    this.condoleanceFormErrors = document.getElementById(
      'condoleanceFormErrors'
    ); // Element to display errors
    this.condoleanceFormSubmit = this.condoleanceForm.querySelector(
      'button[type="submit"]'
    );

    // Condoleance form single fields
    this.lastname = document.getElementById('CondoleanceForm-lastname');
    this.firstname = document.getElementById('CondoleanceForm-firstname');
    this.email = document.getElementById('CondoleanceForm-email');
    this.message = document.getElementById('CondoleanceForm-message');
    // Character counter for message field
    this.messageCounter = this.message ? this.message.parentElement.querySelector('.field__counter') : null;

    // Condoleance product form
    this.condoleanceProductAuthor = document.querySelectorAll(
      '[data-checkout-avis-author]'
    );
    this.condoleanceProductMessage = document.querySelectorAll(
      '[data-checkout-avis-message]'
    );

    // Condoleance form submit button
    this.condoleanceFormTriggerSubmit = document.querySelectorAll(
      '[data-trigger-condoleance]'
    );

    // Condoleance form buy with flower button
    this.condoleanceFormBuyWithFlower = document.querySelectorAll(
      '[data-buy-with-flower]'
    );
  }

  connectedCallback() {
    this.init();

    if (this.condoleanceForm)
      this.condoleanceForm.addEventListener(
        'submit',
        this.handleCondoleanceSubmit.bind(this)
      );

    if (this.condoleanceFormFields) {
      this.condoleanceFormFields.forEach((field) => {
        field.addEventListener(
          'keyup',
          this.handleCondoleanceFormFieldsChanges.bind(this)
        );
      });
    }

    if (this.condoleanceFormTriggerSubmit) {
      this.condoleanceFormTriggerSubmit.forEach((trigger) => {
        trigger.addEventListener(
          'click',
          this.handleCondoleanceFormTriggerSubmit.bind(this)
        );
      });
    }

    if (this.condoleanceFormBuyWithFlower) {
      this.condoleanceFormBuyWithFlower.forEach((flower) => {
        flower.addEventListener(
          'click',
          this.handleCondoleanceFormBuyWithFlower.bind(this)
        );
      });
    }

    // Initialize the character counter for message field
    if (this.message && this.messageCounter) {
      // Set initial counter value
      const maxLength = this.message.getAttribute('maxlength') || 1000;
      this.messageCounter.textContent = `0/${maxLength}`;

      // Add input event listener for character counting
      this.message.addEventListener('input', this.handleCharacterCount.bind(this));
    }
  }

  disconnectedCallback() {
    // Condoleance form
    this.condoleanceForm.removeEventListener(
      'submit',
      this.handleCondoleanceSubmit.bind(this)
    );

    if (this.condoleanceFormTriggerSubmit) {
      this.condoleanceFormTriggerSubmit.forEach((trigger) => {
        trigger.removeEventListener(
          'click',
          this.handleCondoleanceFormTriggerSubmit.bind(this)
        );
      });
    }

    if (this.condoleanceFormFields) {
      this.condoleanceFormFields.forEach((field) => {
        field.removeEventListener(
          'keyup',
          this.handleCondoleanceFormFieldsChanges.bind(this)
        );
      });
    }

    if (this.condoleanceForm) {
      this.condoleanceForm.removeEventListener(
        'submit',
        this.handleCondoleanceSubmit.bind(this)
      );
    }

    // Remove character counter event listener
    if (this.message) {
      this.message.removeEventListener('input', this.handleCharacterCount.bind(this));
    }
  }

  init() {
    // console.log('CondoleancePopover');
  }

  /**
   * Handle character count for the message textarea
   * @param {Event} event - The input event object
   */
  handleCharacterCount(event) {
    if (!this.message || !this.messageCounter) return;

    const textLength = event.target.value.length;
    const maxLength = this.message.getAttribute('maxlength') || 1000;
    this.messageCounter.textContent = `${textLength}/${maxLength}`;
    this.messageCounter.classList.toggle('field__counter--limit', textLength >= maxLength - 50);
  }

  /**
   * Handle condoleance form fields changes
   * sync condoleance product form fields with
   * condoleance form fields
   * @param {Event} event - The event object
   */
  handleCondoleanceFormFieldsChanges(event) {
    // cync author
    this.condoleanceProductAuthor.forEach((author) => {
      author.value =
        this.lastname.value +
        ' ' +
        this.firstname.value +
        ' [ email: ' +
        this.email.value +
        ' ]';
    });
    this.condoleanceProductMessage.forEach((message) => {
      message.value = this.message.value;
    });

    // console.log("author: " + this.condoleanceProductAuthor.value);
    // console.log("message: " + this.condoleanceProductMessage.value);
  }

  async handleCondoleanceSubmit(event) {
    event.preventDefault();

    // select avis
    this.updateAvisGlobalContext();

    this.condoleanceFormErrors.innerHTML = ''; // Clear previous errors
    this.condoleanceFormErrors.classList.add('tw-hidden');

    // Add sending class
    this.condoleanceForm.classList.add('sending');

    this.condoleanceFormTriggerSubmit.forEach((trigger) => {
      trigger.classList.add('sending');
      trigger.disabled = true;
    });

    // Collect form data
    const plainObject = {};
    const formData = new FormData(this.condoleanceForm);
    formData.forEach((value, key) => {
      plainObject[key] = value;
    });


    let developmentModeUrl = window?.developmentMode?.url ? `${window?.developmentMode?.url}/api/shopify/condolences/send` : `https://yves-legare-server.vercel.app/api/shopify/condolences/send`;
    let developmentModeEnabled = window?.developmentMode?.enabled;
    let url = developmentModeEnabled ? developmentModeUrl : `https://yves-legare-server.vercel.app/api/shopify/condolences/send`;
    let targetStoreHeader = window?.targetStore?.enabled ? window?.targetStore?.value : null;

    let headers = {
      'Content-Type': 'application/json',
    };

    if (targetStoreHeader) {
      headers['x-target-store'] = targetStoreHeader;
    };

    try {
      const response = await fetch(
        url,
        {
          method: 'POST',
          body: JSON.stringify(plainObject),
          headers: headers,
        }
      );

      const responseObject = await response.json();

      if (!responseObject.success) {
        console.warn('error failed to post !');

        // Add error class
        this.condoleanceForm.classList.remove('sending');
        this.condoleanceForm.classList.add('error');

        // Remove sending class from triggers
        this.condoleanceFormTriggerSubmit.forEach((trigger) => {
          trigger.classList.remove('sending');
          trigger.disabled = false;
        });

        return;
      }

      // Handle success
      this.condoleanceForm.classList.remove('sending');
      this.condoleanceForm.classList.add('success');

      this.condoleanceFormTriggerSubmit.forEach((trigger) => {
        trigger.classList.remove('sending');
        trigger.disabled = false;
      });


      // Fade out form and show success message
      this.condoleanceForm.style.opacity = '0';
      this.condoleanceForm.style.transition = 'opacity 300ms';

      // handle form container display
      this.condoleanceFormContainer.style.display = 'none';
      this.condoleanceFormSuccess.style.display = 'flex';

      // After successful submission, dispatch formComplete event
      this.condoleanceForm.dispatchEvent(new CustomEvent('formComplete'));
    } catch (error) {
      console.error('Error:', error);

      this.condoleanceForm.classList.remove('sending');
      this.condoleanceForm.classList.add('error');

      this.condoleanceFormTriggerSubmit.forEach((trigger) => {
        trigger.classList.remove('sending');
        trigger.disabled = false;
      });

      // Show error message
      // const errorDiv = document.createElement('div');
      // errorDiv.className = 'errors';
      // errorDiv.textContent = error.message;
      // this.condoleanceForm.insertAdjacentElement('beforebegin', errorDiv);
    }
  }

  // Select avis from condoleance form
  updateAvisGlobalContext() {
    if (this.masterAvisInfosContainer) {
      console.log('- updateAvisGlobalContext -');
      const avisData = {
        id: this.masterAvisInfosContainer.dataset.id,
        contrat: this.masterAvisInfosContainer.dataset.contrat,
        image: this.masterAvisInfosContainer.dataset.image,
        complexe: this.masterAvisInfosContainer.dataset.complexe,
        expoAddress: this.masterAvisInfosContainer.dataset.expoaddress,
        expoDay: this.masterAvisInfosContainer.dataset.expoday,
        expoHour: this.masterAvisInfosContainer.dataset.expohour,
        dates: this.masterAvisInfosContainer.dataset.dates,
        name: this.masterAvisInfosContainer.dataset.name,
      };

      // set global context
      sessionStorage.setItem('avisDataProduct', JSON.stringify(avisData));

      // reload avis association by event
      document.dispatchEvent(new Event('avis:reload'), {
        detail: avisData,
        bubbles: true,
      });
    }
  }

  /**
   * Handle condoleance form trigger submit
   * @param {Event} event - The event object
   */
  handleCondoleanceFormTriggerSubmit(event) {
    event.preventDefault();
    this.condoleanceFormSubmit.click();
  }

  /**
   * Handle condoleance form trigger submit
   * @param {Event} event - The event object
   */
  handleCondoleanceFormBuyWithFlower(event) {
    event.preventDefault();

    // Click submit button
    this.condoleanceFormSubmit.click();

    // Add sending class
    this.condoleanceFormSuccess.classList.add('sending-flower');

    // Add listener for form submission completion
    const handleFormComplete = () => {
      let condoleanceFormCheckoutButton = document.querySelectorAll(
        '.product-form__checkout shopify-buy-it-now-button button, shop-pay-wallet-button gravity-button'
      );

      // console.log('condoleanceFormCheckoutButton');
      // console.log(condoleanceFormCheckoutButton);

      // Default behavior: clock to form quick add button
      if (condoleanceFormCheckoutButton.length > 0) {
        setTimeout(() => {
          condoleanceFormCheckoutButton[0].click();
        }, 2000);
      }
      else {
        console.log('No quick buy button found');

        // execute the prevented default behavior
        // add to cart
        let defaultPauymentButton = document.getElementById('buy-with-flower');
        defaultPauymentButton.click();

        // Add sending class
        this.condoleanceFormSuccess.classList.remove('sending-flower');
      }
    };

    this.condoleanceForm.addEventListener('formComplete', handleFormComplete, {
      once: true,
    });
  }
}

// Define the custom element if not already defined
if (!customElements.get('condoleance-popover')) {
  customElements.define('condoleance-popover', CondoleancePopover);
}
